import {useRouteError} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Switch} from "@headlessui/react";
import { useTranslation } from 'react-i18next';


export default function CreateFace() {
    const { t, i18n }:any = useTranslation('manageuser');
    const [statusMessage, setStatusMessage] = useState(null);
    const [detailStatusMessage, setDetailStatusMessage] = useState(null);
    const [faces, setFaces] = useState<any[]>([]);
    const stopBouncing = () => {
        const el = document.getElementById("promo-icon");
        if (el) {
            el.classList.remove("animate-bounce");
        }
    }
    useEffect(() => {
        setTimeout(() => stopBouncing(), 3500)
    }, []);
    const verifyUser = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/user/sendemailverification.do`, {
            instance: 'promogogo',
            ticket: localStorage.getItem('ticket'),
            server: "https://backstage.promogogo.com"
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log('verifyUser',response);
            window.location.href = '/manage/user';

        });
    }
    const submitForm = (e) => {
        e.preventDefault();
        setStatusMessage(null);
        setDetailStatusMessage(null)
        e.preventDefault(); // Prevent default form submission (page reload)
        let formData2 = new FormData(e.target);
        const urlEncoded = new URLSearchParams();
        for (const [key, value] of formData2.entries()) {
            if (typeof value === "string")
            {
                urlEncoded.append(key, value);
            }
        }
        urlEncoded.append("ticket", localStorage.getItem('ticket'));
        axios.post(process.env.REACT_APP_API_URL + '/p/user/createface.do', urlEncoded,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }})
            .then(function (response) {
                console.log(response);
                window.location.href = '/manage/user';

            })
            .catch(function (error) {
                console.log(error);
                setStatusMessage(error.message)
                setDetailStatusMessage(error.response.data.error)
            });
    };

    const searchFaces = (e) => {
        e.preventDefault();
        if(e.target.value.length > 2)
        {
            let params = new URLSearchParams();
            params.append('faces', "true");
            params.append('q', e.target.value);
            axios.post(process.env.REACT_APP_API_URL + '/p/ajax/search/searchsuggest.do', params,{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }})
                .then(function (response) {
                    console.log(response);
                    setFaces(response.data.collection);

                    //window.location.href = '/manage/user';

                })
                .catch(function (error) {
                    console.log(error);
                    setStatusMessage(error.message)
                    setDetailStatusMessage(error.response.data.error)
                });
        }
        else {
            setFaces([]);
        }

    };


    return (<div className="mt-2">

        <div className="sm:mx-auto sm:w-full sm:max-w-sm ">

            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-pg_blue">{t('createsite')}</h2>
        </div>
        <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm bg-white rounded p-3">
            <form id="createform" className="space-y-6" onSubmit={submitForm}>
                <input type="hidden" name="instance" value="promogogo"/>
                <input type="hidden" name="appName" value="mobilitus"/>

                <div>
                    <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">{t('nameofaccount')}</label>
                    <div className="mt-2">
                        <input id="name" name="title" type="text" autoComplete="name" required
                               onChange={(e) => searchFaces(e)}
                               className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                    {faces && faces.length > 0 && <div className={'mt-2'}>
                           <h1 className={'text-pg_blue'}>We found matching sites.</h1>
                        {faces.map((face) => <div key={face.guid} className="col-span-1 overflow-hidden bg-white shadow sm:rounded-lg">
                        <div className={'text-2xl'}>{face.name}</div>

                    </div>)}
                    </div>}
                </div>
                <div className={'mt-2'}>
                    <div className={'text-pg_blue'}>
                        {t('createinfo')}
                    </div>
                </div>
                <div>
                    <label htmlFor="nameInvoice" className="block text-sm font-medium leading-6 text-gray-900">{t('nameofbusiness')}</label>
                    <div className="mt-2">
                        <input id="loginName" name="nameInvoice" type="text"
                               className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>
                <div>
                    <label htmlFor="ktInvoice" className="block text-sm font-medium leading-6 text-gray-900">{t('kennitala')}</label>
                    <div className="mt-2">
                        <input id="loginName" name="ktInvoice" type="text"
                               className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div>
                    <label htmlFor="emailInvoice" className="block text-sm font-medium leading-6 text-gray-900">{t('emailforinvoicing')}</label>
                    <div className="mt-2">
                        <input id="loginName" name="emailInvoice" type="email"  autoComplete={'email'}
                               className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div>
                    <label htmlFor="poInvoice" className="block text-sm font-medium leading-6 text-gray-900">{t('podepartment')}</label>
                    <div className="mt-2">
                        <input id="loginName" name="poInvoice" type="text"
                               className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div>
                    <label htmlFor="webInvoice" className="block text-sm font-medium leading-6 text-gray-900">{t('urltopost')}</label>
                    <div className="mt-2">
                        <input id="loginName" name="webInvoice" type="text"
                               className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div>
                    <label htmlFor="eInvoice" className="block text-sm font-medium leading-6 text-gray-900">{t('electronicinvoicing')}</label>
                    <div className="mt-2">
                        <Switch
                            name={'eInvoice'}
                            className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                        >
                            <span className="sr-only">Send Invoice Electronically</span>
                            <span
                                aria-hidden="true"
                                className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                            />
                        </Switch>


                    </div>
                </div>

                <div>
                    <button type="submit"
                            className="flex w-full justify-center rounded-md bg-orange-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">{t('createbutton')}
                    </button>
                </div>
                <div className="text-center text-red-500 p-1">
                    {statusMessage && <span className="text-center text-red-500 p-1">{statusMessage}</span>}
                    {detailStatusMessage &&
                     <span className="text-center text-red-500 p-1"><br/>{detailStatusMessage}</span>}
                </div>

            </form>

        </div>
    </div>);
}
